import React, { PropsWithChildren } from 'react';
import Container from '@mui/material/Container';
import { i18n_related } from '@yi/i18n/phrases/i18n_related';

import { PrintHidden, useLocale } from '~/components';

import { RelatedArticlesHeading } from './elements';

interface Props {
  renderRelatedCarousel(): React.ReactElement;
}

export const RelatedContent: React.FC<PropsWithChildren<Props>> = ({ renderRelatedCarousel }) => {
  const { locale } = useLocale();
  return (
    <PrintHidden>
      <RelatedArticlesHeading>{i18n_related(locale)}</RelatedArticlesHeading>
      <Container>{renderRelatedCarousel()}</Container>
    </PrintHidden>
  );
};
